import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table table-bordered" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-2",
      style: {"width":"50%"}
    }, " Категория "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-2",
      colspan: "2"
    }, " Цена ")
  ])
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "px-3 py-2" }
const _hoisted_5 = { class: "px-3 py-2" }
const _hoisted_6 = { class: "px-3 py-2" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "px-3 py-2" }
const _hoisted_9 = { class: "px-3 py-2" }
const _hoisted_10 = { class: "px-3 py-2 d-flex" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-md",
    title: _ctx.state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("table", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exceptions, (e, eInd) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (e.type === 'edit')
                ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                    _createElementVNode("td", _hoisted_4, _toDisplayString(e.contractorCategoryName), 1),
                    _createElementVNode("td", _hoisted_5, [
                      _createVNode(_component_input_ui, {
                        modelValue: e.price,
                        "onUpdate:modelValue": ($event: any) => ((e.price) = $event),
                        placeholder: "Цена",
                        onInput: ($event: any) => (_ctx.editHandler(e))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _createElementVNode("td", _hoisted_6, [
                      _createVNode(_component_button_ui, {
                        "button-class": "btn-danger",
                        onClick: ($event: any) => (_ctx.deleteHandler(e, eInd))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" х ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (e.type === 'add')
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _createElementVNode("td", _hoisted_8, [
                      _createVNode(_component_select_ui, {
                        "item-key": "categoryName",
                        options: _ctx.categories,
                        placeholder: "Название",
                        searchable: true,
                        values: [e.contractorCategoryId],
                        onOnSelected: (v) => _ctx.onCategorySelected(e, v)
                      }, null, 8, ["options", "values", "onOnSelected"])
                    ]),
                    _createElementVNode("td", _hoisted_9, [
                      _createVNode(_component_input_ui, {
                        modelValue: e.price,
                        "onUpdate:modelValue": ($event: any) => ((e.price) = $event),
                        placeholder: "Цена"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("td", _hoisted_10, [
                      _createVNode(_component_button_ui, {
                        "button-class": "btn-success",
                        onClick: ($event: any) => (_ctx.addHandler(e, eInd))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" ✓ ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_button_ui, {
                        "button-class": "btn-danger ms-3",
                        onClick: ($event: any) => (_ctx.deleteHandler(e, eInd))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" х ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_button_ui, {
            "button-class": "btn-primary",
            onClick: _ctx.addNewHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Добавить исключение ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}